<template>
  <div>

    <div :id="divName" ></div>
  </div>
</template>
<script setup>
  import { ref, onMounted, watch, toRefs } from "vue";
  import * as d3 from 'd3';
  const props = defineProps({
    name:{type: String, default: null},
    divName:{type: String},
    colors:{type:Object},
    dialVal: {type:Number},
    dialConfig:{type:Object},
    desc:{type: String, default: null},
    showInfo: {type:Boolean, default:true},
    minimalPadding:{type:Boolean, default:false},
  })

  

  const { divName } = toRefs(props)
  const { colors } = toRefs(props)
  const { dialVal } = toRefs(props)
  const { dialConfig } = toRefs(props)

  const data = dialConfig
  // console.log(data)
  onMounted(() => {
    updateDial()
  })
  watch(dialVal, (newVal, oldVal)=>{
    updateDial()
  })

  const updateDial = () => {
    

    const chartSelector = divName.value;
    const gauge = function(container, configuration) {
      const returnObj = {};
      const config = {
        size            : 210,
        clipWidth          : 210,
        clipHeight          : 120,
        ringWidth          : 20,
        ringInset          : 20,
        pointerWidth        : 10,
        pointerTailLength      : 5,
        pointerHeadLengthPercent  : 0.9,
        minVal          : data.value.minVal,
        maxVal          : data.value.maxVal,
        minAngle          : -90,
        maxAngle          : 90,
        transitionMs        : 5000,
        majorTicks          : data.value.majorTicks,
        ticks               : data.value.ticks,
        tickData            : [0.21428571428, 0.214285, 0.18, 0.1436, 0.144, 0.130, 0.463], //this.data.tickData, //
        labelInset          : 15,
        // arcColorFn          : d3.interpolateHsl(d3.rgb('#e8e2ca'), d3.rgb('#3e6c0a'))
      };
      let range = undefined;
      let r = undefined;
      let pointerHeadLength = undefined;
      let value = 0;
      let svg = undefined;
      let arc = undefined;
      let scale = undefined;
      let ticks = undefined;
      let tickData = undefined;
      let pointer = undefined;

      let labelFormat

      if (data.value.numDecimals === 0){labelFormat = d3.format('d')}
      else if(data.value.numDecimals === 1){labelFormat = d3.format('.1f')}         
      else if(data.value.numDecimals === 2){labelFormat = d3.format('.2f')} 
      else{labelFormat = d3.format('d')}



      function deg2rad(deg) {
        return deg * Math.PI / 180;
      }
      function newAngle(d) {
        const ratio = scale(d);
        const newAngle = config.minAngle + (ratio * range);
        return newAngle;
      }

      function configure(configuration) {

        let prop = undefined;
        for ( prop in configuration ) {
          config[prop] = configuration[prop];
        }
        range = config.maxAngle - config.minAngle;
        r = config.size / 2;
        pointerHeadLength = Math.round(r * config.pointerHeadLengthPercent);

        // a linear scale returnObj maps domain values to a percent from 0..1
        scale = d3.scaleLinear()
          .range([0,1])
          .domain([config.minVal, config.maxVal]);


        ticks = config.ticks;
        tickData = config.tickData;

        arc = d3.arc()
          .innerRadius(r - config.ringWidth - config.ringInset)
          .outerRadius(r - config.ringInset)
          .startAngle(function(d, i) {
            const ratio = d * i;
            return deg2rad(config.minAngle + (ratio * range));
          })
          .endAngle(function(d, i) {
            const ratio = d * (i+1);
            return deg2rad(config.minAngle + (ratio * range));
          });
      }
      returnObj.configure = configure;
      function centerTranslation() {
        return 'translate('+r +','+ r +')';
      }

      function isRendered() {
        return (svg !== undefined);
      }

      returnObj.isRendered = isRendered;

      //label szie
      const labSize = data.value.labelSize.toString() + "px"

      function render(newValue) {
        // console.log(config)
        svg = d3.select(container)
            .append('svg:svg')
            .attr('class', 'gauge')
            .attr('id', chartSelector + "_svg")
            // .attr('width', config.clipWidth)
            // .attr('height', config.clipHeight);
            .attr("preserveAspectRatio", "xMinYMin meet")
            .attr("viewBox", "0 0 " +config.clipWidth + " " + config.clipHeight)
            .classed("svg-content-responsive", true)
        const centerTx = centerTranslation();
        const arcs = svg.append('g')
            .attr('class', 'arc')
            .attr('transform', centerTx);
        arcs.selectAll('path')
            .data(tickData)
            .enter().append('path')
            .attr('fill', function(d, i) {
                return config.arcColorFn(d * i);
            })
            .attr("id", function(d, i) {
                return "label"+ parseFloat(i);
            })
            .attr('d',arc);
        const lg = svg.append('g')
            .attr('class', 'label')
            .attr('transform', centerTx);

        lg.selectAll('text')
            .data(ticks)
            .enter()
            .append('text')
            .style("text-anchor","middle")
            .attr('transform', function(d) {
                const ratio = scale(d);
                const newAngle = config.minAngle + (ratio * range);
                if (isNaN(newAngle) == false){
                  return 'rotate(' +newAngle +') translate(-1,' +(config.labelInset - r) +')';
                }
            })
            .text(labelFormat)
            .style("font-size", labSize)
            .attr('class', 'd3-text')


        const lineData = [ [config.pointerWidth / 2, 0],
              [0, -pointerHeadLength],
              [-(config.pointerWidth / 2), 0],
              [0, config.pointerTailLength],
              [config.pointerWidth / 2, 0] ];
        const pointerLine = d3.line().curve(d3.curveMonotoneX);
        const pg = svg.append('g')
              .data([lineData])
              // .attr('class', 'pointer') // this gets used elsewhere to style cursor as pointer
              .attr('fill', 'black')
              .attr('transform', centerTx);

        pointer = pg.append('path')
          .attr('d', pointerLine)
          .attr('transform', 'rotate(' +config.minAngle +')');
        update(newValue === undefined ? 0 : newValue);

      }

      returnObj.render = render;

      function update(newValue, newConfiguration) {
        // console.log("updating");
        if ( newConfiguration  !== undefined) {
          configure(newConfiguration);
        }
        const ratio = scale(newValue);
        const newAngle = config.minAngle + (ratio * range);
        if (isNaN(newAngle) == false){
          pointer.transition()
            .duration(config.transitionMs)
            .ease(d3.easeElastic)
            .attr('transform', 'rotate(' +newAngle +')');
        }
      }
      returnObj.update = update;
      configure(configuration);
      return returnObj;
    }.bind(this);

    d3.select("#" + chartSelector).select("svg").remove();

    const dial = gauge("#" + chartSelector, {
        ticks : data.value.ticks,
        majorTicks : parseFloat(data.value.majorTicks),
        tickData: d3.range(data.value.majorTicks).map(function(){return 1/data.value.majorTicks;}.bind(this)),// d3.range(this.data.majorTicks).map(function() {return 1/this.data.majorTicks;}),
        //arcColorFn : d3.interpolateHsl(d3.rgb(colors.value.color1), d3.rgb(colors.value.color2), d3.rgb(colors.value.color3)),
        arcColorFn: d3.interpolateRgbBasis([d3.rgb(colors.value.color1), d3.rgb(colors.value.color2), d3.rgb(colors.value.color3)]),
        minVal: data.value.minVal,
        maxVal: data.value.maxVal
    });
    dial.render();

    //if the value is less than the min or more than max, draw those.
    // make a little buffer so the needle stays visible
    let buff = (data.value.maxVal-data.value.minVal) * 0.03
    if (dialVal.value <= data.value.minVal){dial.update(data.value.minVal + buff)}
    else if (dialVal.value >= data.value.maxVal){dial.update(data.value.maxVal - buff)}
    else{dial.update(dialVal.value)}


    if (data.value.labels != undefined){
      // console.log(data.value.labels)
      for (let i=0; i<data.value.labels.length; i++){
        d3.select( "#" + chartSelector + "_svg").selectAll("text") // only select the text in the active chart (by ID)
          .filter(function(){

            if (data.value.ticks[i] <0){            
              return d3.select(this).text() == '\u2212' + data.value.ticks[i]*-1 //convert to positive and use unicode negative
            }
            else{
              // console.log(`changing ${data.value.ticks[i]} to ${data.value.labels[i]}`)
              return d3.select(this).text() ==  data.value.ticks[i]
            }
          })
         .text(data.value.labels[i])
      }
    }

    // // these get rounded so handle separately
    // d3.selectAll("text")
    //   .filter(function(){
    //     return d3.select(this).text() == 2 //actual value is 1.75, but gets rounded to 2
    //   })
    //   .text("Far More")

    // d3.select("#" + chartSelector).selectAll("text")
    //   .filter(function(){
    //     return d3.select(this).text() === '\u22122' //u2212 is the unicode negative sign used by d3 . actual value is 1.75, but gets rounded to -2
    //   })
    //   .text("Far Less")
 

  }



</script>
<style scoped>
.med-text{
  font-size: 14px;
}

.q-dark .text .d3-text{
  fill: white !important;
}
</style>
